import {CONSTANTS, Toast} from './Toast'

const defaultSettings = {
  position: CONSTANTS.POSITIONS.TOP_RIGHT
}
// title: 'Target Download Complete', message: `Completed downloading the file ${filename}.`
class ToastFactory extends Toast {
  constructor (setupOptions) {
    super(setupOptions || defaultSettings)
  }
}

export default new ToastFactory()



// WEBPACK FOOTER //
// ./src/app/components/common/toasts/ToastFactory.js